import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { apiAxios } from "../../../../utils/apiAxios";

interface CancellationItem {
  cancellationID: number;
  caseID: number;
  orderID: string;
  patientName: string;
  clinicName: string;
  cancellationReason: string;
  remarks: string;
  requestedDate: string;
  currentStatus: string;

  // ✅ NEW
  paidAmount: number;
  suggestedRefundAmount: number;
  deductionAmount: number;
  deductionType: string;
  deductionValue: number;
  phaseName: string;
  allowCustomRefund: boolean;
  minRefundAmount: number;
  maxRefundAmount: number;
}

const CancellationManagement: React.FC = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState<CancellationItem[]>([]);

  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);

  const [selectedItem, setSelectedItem] =
    useState<CancellationItem | null>(null);

  const [refundAmount, setRefundAmount] = useState("");
  const [isCustomRefund, setIsCustomRefund] = useState(false);

  const enteredRefund = Number(refundAmount || 0);
  const isRefundExceeded = selectedItem && enteredRefund > selectedItem.paidAmount;

  const [rejectReason, setRejectReason] = useState("");
  const [expandedReasons, setExpandedReasons] = useState<number[]>([]);
  useEffect(() => {
    fetchCancellationRequests();
  }, []);

  const fetchCancellationRequests = async () => {
    try {
      setLoading(true);

      const token = sessionStorage.getItem("token") || "";

      const res = await apiAxios.get(
        `${API_BASE_URL}/Dentist/pending-list`,
        {
          headers: {
            AuthorizationData: token
          }
        }
      );

      if (res.data.isSuccess) {
        setRequests(res.data.singleData || []);
      }
    } catch (err) {
      console.warn(err);
      toast.error("Failed to load requests");
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async () => {
    try {
      if (!selectedItem) return;

      const refund = Number(refundAmount);


      if (selectedItem.paidAmount > 0) {
        if (refund < 1 || refund > selectedItem.paidAmount) {
          toast.error(
            `Refund Amount must be between 1 and ₹${selectedItem.paidAmount.toFixed(2)}`
          );
          return;
        }
      } else {
        if (refund !== 0) {
          toast.error("Refund Amount must be 0.");
          return;
        }
      }

      const token = sessionStorage.getItem("token") || "";

      const payload = {
        caseID: selectedItem.caseID,
        refundAmount: refund,
        isCustomRefund
      };

      const res = await apiAxios.post(
        `${API_BASE_URL}/Dentist/cancel-approvepage`,
        payload,
        {
          headers: {
            AuthorizationData: token,
            "Content-Type": "application/json"
          }
        }
      );

      if (res.data?.isSuccess) {
        toast.success("Cancellation approved");

        setShowApproveModal(false);
        setRefundAmount("");
        setSelectedItem(null);
        setIsCustomRefund(false);

        fetchCancellationRequests();
      } else {
        toast.error(res.data?.message);
      }
    } catch (err: any) {
      console.warn(err);

      toast.error(
        err?.response?.data?.message ||
        "Approval failed"
      );
    }
  };

  const formatDateTime = (dateString: string) => {
    if (!dateString) return "-";

    return new Date(dateString).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handleReject = async () => {
    try {
      if (!selectedItem) return;

      if (!rejectReason.trim()) {
        toast.error("Please enter rejection reason");
        return;
      }

      const token = sessionStorage.getItem("token") || "";

      const payload = {
        caseID: selectedItem.caseID,
        reason: rejectReason
      };

      const res = await apiAxios.post(
        `${API_BASE_URL}/Dentist/reject`,
        payload,
        {
          headers: {
            AuthorizationData: token,
            "Content-Type": "application/json"
          }
        }
      );

      if (res.data?.isSuccess) {
        toast.success("Cancellation rejected");

        setShowRejectModal(false);
        setRejectReason("");
        setSelectedItem(null);

        fetchCancellationRequests();
      } else {
        toast.error(res.data?.message);
      }
    } catch (err: any) {
      console.warn(err);

      toast.error(
        err?.response?.data?.message ||
        "Rejection failed"
      );
    }
  };

  return (
    <div className="container-fluid ">
      <h4
        className="mb-3"
      >
        Cancellation Requests
      </h4>
      <div
        className="premium-card mb-4 p-3"
      // style={{ maxWidth: "480px" }}
      >



        <div
          style={{
            background: "#fff",
            borderRadius: "10px",
            padding: "20px",
            overflowX: "auto"
          }}
        >
          <div className="custom-table-wrapper">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Case ID</th>
                  <th>Patient</th>
                  <th>Clinic</th>
                  <th>Reason</th>
                  <th>Phase</th>
                  <th>Paid</th>
                  <th>Suggested Refund</th>
                  <th>Requested Date</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={11} className="text-center py-4">
                      Loading...
                    </td>
                  </tr>
                ) : requests.length === 0 ? (
                  <tr>
                    <td colSpan={11} className="text-center py-4">
                      No pending requests
                    </td>
                  </tr>
                ) : (
                  requests.map((item) => (
                    <tr key={item.cancellationID}>
                      <td>{item.orderID}</td>

                      <td>{item.caseID}</td>

                      <td>{item.patientName}</td>

                      <td>{item.clinicName}</td>

                      {/* <td>{item.cancellationReason}</td> */}
                      <td>
                        {item.cancellationReason?.length > 50 ? (
                          <>
                            {expandedReasons.includes(item.cancellationID)
                              ? item.cancellationReason
                              : `${item.cancellationReason.substring(0, 50)}...`}

                            <button
                              type="button"
                              style={{
                                border: "none",
                                background: "transparent",
                                color: "#0d6efd",
                                marginLeft: "5px",
                                cursor: "pointer",
                                fontSize: "12px"
                              }}
                              onClick={() => {
                                setExpandedReasons(prev =>
                                  prev.includes(item.cancellationID)
                                    ? prev.filter(id => id !== item.cancellationID)
                                    : [...prev, item.cancellationID]
                                );
                              }}
                            >
                              {expandedReasons.includes(item.cancellationID)
                                ? "View Less"
                                : "View More"}
                            </button>
                          </>
                        ) : (
                          item.cancellationReason
                        )}
                      </td>

                      <td>
                        <div
                          style={{
                            fontWeight: 600
                          }}
                        >
                          {item.phaseName}
                        </div>

                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666"
                          }}
                        >
                          {item.deductionType}
                          {" - "}
                          {item.deductionValue}
                        </div>
                      </td>

                      <td>
                        ₹
                        {Number(item.paidAmount || 0).toFixed(2)}
                      </td>

                      <td>
                        <div
                          style={{
                            color: "#198754",
                            fontWeight: 700
                          }}
                        >
                          ₹
                          {Number(
                            item.suggestedRefundAmount || 0
                          ).toFixed(2)}
                        </div>

                        <div
                          style={{
                            fontSize: "12px",
                            color: "#dc3545"
                          }}
                        >
                          Deduction ₹
                          {Number(
                            item.deductionAmount || 0
                          ).toFixed(2)}
                        </div>
                      </td>

                      <td>{formatDateTime(item.requestedDate)}</td>

                      <td>
                        <span
                          style={{
                            background: "#ffcd39",
                            padding: "5px 10px",
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: 600
                          }}
                        >
                          {item.currentStatus}
                        </span>
                      </td>

                      <td>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px"
                          }}
                        >
                          <button
                            className="btn btn-success btn-sm"
                            onClick={() => {
                              setSelectedItem(item);
                              setRefundAmount( Number(item.suggestedRefundAmount || 0).toFixed(2));
                              setIsCustomRefund(false);

                              setShowApproveModal(true);
                            }}
                          >
                            Approve
                          </button>

                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                              setSelectedItem(item);
                              setShowRejectModal(true);
                            }}
                          >
                            Reject
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

          </div></div>


        {/* APPROVE MODAL */}
        {showApproveModal && selectedItem && (
          <div className="modal-overlay">
            <div className="custom-modal">
              <h4>Approve Cancellation</h4>
              <div className="refund-summary-box">
                <div>
                  <span>Paid Amount</span>
                  <strong>
                    ₹{selectedItem.paidAmount.toFixed(2)}
                  </strong>
                </div>

                <div>
                  <span>Deduction</span>

                  <strong style={{ color: "#dc3545" }}>
                    ₹
                    {selectedItem.deductionAmount.toFixed(2)}
                  </strong>
                </div>

                <div>
                  <span>Suggested Refund</span>

                  <strong style={{ color: "#198754" }}>
                    ₹
                    {selectedItem.suggestedRefundAmount.toFixed(
                      2
                    )}
                  </strong>
                </div>
              </div>

              {selectedItem.allowCustomRefund && (
                <div className="mt-3">
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      checked={isCustomRefund}
                      onChange={(e) =>
                        setIsCustomRefund(
                          e.target.checked
                        )
                      }
                    />

                    Custom Refund
                  </label>
                </div>
              )}

              <div className="mt-3">
                <label>Refund Amount</label>

                <input
                  type="number"
                  className="form-control mt-2"
                  disabled={!isCustomRefund}
                  min={selectedItem.paidAmount > 0 ? 1 : 0}
                  max={selectedItem.paidAmount}
                  value={refundAmount}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === "") {
                      setRefundAmount("");
                      return;
                    }

                    const amount = Number(value);

                    if (selectedItem.paidAmount > 0) {
                      if (amount < 1) {
                        setRefundAmount("1");
                      } else if (amount > selectedItem.paidAmount) {
                        setRefundAmount(String(selectedItem.paidAmount));
                      } else {
                        setRefundAmount(value);
                      }
                    } else {
                      setRefundAmount("0");
                    }
                  }}
                />
                {isRefundExceeded && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "5px"
                    }}
                  >
                    Refund Amount cannot be greater than Paid Amount
                    (₹{selectedItem.paidAmount.toFixed(2)})
                  </div>
                )}

                {isCustomRefund && (
                  <div
                    style={{
                      fontSize: "12px",
                      marginTop: "6px",
                      color: "#666"
                    }}
                  >
                    Allowed Range :
                    ₹{selectedItem.paidAmount > 0 ? 1 : 0}
                    {" - "}₹
                    {selectedItem.paidAmount}
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  marginTop: "20px"
                }}
              >
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowApproveModal(false);
                    setRefundAmount("");
                    setSelectedItem(null);
                    setIsCustomRefund(false);
                  }}
                >
                  Close
                </button>

                {!isRefundExceeded && (
                  <button
                    className="btn btn-success"
                    onClick={handleApprove}
                  >
                    Approve Refund
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {/* REJECT MODAL */}
        {showRejectModal && (
          <div className="modal-overlay">
            <div className="custom-modal">
              <h4>Reject Cancellation</h4>

              <div className="mt-3">
                <label>Reject Reason</label>

                <textarea
                  className="form-control mt-2"
                  rows={4}
                  value={rejectReason}
                  onChange={(e) =>
                    setRejectReason(e.target.value)
                  }
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  marginTop: "20px"
                }}
              >

                <button
                  className="btn btn-primary"
                  onClick={handleReject}
                >
                  Reject
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowRejectModal(false);
                    setRejectReason("");
                    setSelectedItem(null);
                  }}
                >
                  Close
                </button>

              </div>
            </div>
          </div>
        )}

        <style>
          {`
    /* Card */
    .shadow-container {
      background: #fff;
      border-radius: 24px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.08);
    }

    /* Table Wrapper */
    .custom-table-wrapper {
      width: 100%;
      overflow-x: auto;
      border-radius: 18px;
      background: #fff;
    }

    /* Table */
    .custom-table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      min-width: 1400px;
    }

    /* Header */
    .custom-table thead th {
      background: #fff;
      color: #1f2937;
      font-size: 15px;
      font-weight: 700;
      padding: 22px 24px;
      border-bottom: 1px solid #e5e7eb;
      white-space: nowrap;
    }

    .custom-table thead th:first-child {
      border-top-left-radius: 14px;
    }

    .custom-table thead th:last-child {
      border-top-right-radius: 14px;
    }

    /* Rows */
    .custom-table tbody tr {
      background: #fafafa;
    }
  .custom-table thead th{
      border-bottom: none!important;
  }
    .custom-table tbody td {
      padding: 20px 24px;
      vertical-align: middle;
      border-bottom: 1px solid #e5e7eb;
      color: #374151;
      font-size: 14px;
      white-space: nowrap;
          border-right: none;
    border-left: none;
    }

    .custom-table tbody tr:hover {
      background: #f4f6f8;
    }

    /* Status Badge */
    .status-badge {
      background: #fff3cd;
      color: #856404;
      padding: 8px 14px;
      border-radius: 8px;
      font-size: 12px;
      font-weight: 600;
      display: inline-block;
    }

    /* Action Buttons */
    .action-btns {
      display: flex;
      gap: 8px;
    }

    .action-btns .btn-success,
    .action-btns .btn-danger {
      border-radius: 8px;
      font-size: 13px;
      font-weight: 600;
      padding: 6px 14px;
    }

    /* Modal */
    .modal-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    }

    .custom-modal {
      width: 450px;
      background: #fff;
      border-radius: 16px;
      padding: 24px;
      box-shadow: 0 10px 30px rgba(0,0,0,0.15);
    }

    .refund-summary-box {
      background: #f8f9fb;
      border-radius: 12px;
      padding: 15px;
      margin-top: 15px;
    }

    .refund-summary-box div {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .refund-summary-box div:last-child {
      margin-bottom: 0;
    }
  `}
        </style>
      </div>
    </div>
  );
};

export default CancellationManagement;